import { createAction, handleActions } from "redux-actions";

export const initialState = {
  isExpanded: false,
  printSize: "letter",
  printOrientation: "landscape",
};

export const actionPrintExpandToggled = createAction("PRINT_EXPAND_TOGGLED");
export const actionPrintSizeUpdated = createAction("PRINT_SIZE_UPDATED");
export const actionPrintOrientationUpdated = createAction(
  "PRINT_ORIENTATION_UPDATED",
);

export const printReducer = handleActions(
  {
    [actionPrintExpandToggled]: (state, action) => {
      const isExpanded =
        action.payload === null || action.payload === undefined
          ? !state.isExpanded
          : action.payload;
      return { ...state, isExpanded };
    },
    [actionPrintSizeUpdated]: (state, action) => {
      return { ...state, printSize: action.payload };
    },
    [actionPrintOrientationUpdated]: (state, action) => {
      return { ...state, printOrientation: action.payload };
    },
  },
  initialState,
);
